import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { useCurrentExperienceTranslationsQuery } from "@/features/experience-curation/queries/useExperienceTranslationsQuery";
import { useCurrentRawSnapshotsQuery } from "@/features/experience-curation/queries/useRawSnapshotsQuery";
import { useHasCommercialFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { usePrimitiveModelWithChanges } from "@/features/core-shared/composables/usePrimitiveModelWithChanges";
import { useRawCustomerVoucherInfo } from "@/features/experience-raw/sections/customer-info/fields/stores/useRawCustomerVoucherInfo";
import { useIsVoucherInfoVisible } from "@/features/experience-shared/composables/useIsVoucherInfoVisible";

export const useCurationInfoVoucher = defineStore("curation-customer-info-info-voucher-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const translationsQuery = useCurrentExperienceTranslationsQuery();
  const rawSnapshotsQuery = useCurrentRawSnapshotsQuery();
  const rawVoucherInfoStore = useRawCustomerVoucherInfo();

  const initialValue = computed(() => translationsQuery.data.value?.info_voucher ?? "");
  const { model, hasChanges, isFilled, reset } = usePrimitiveModelWithChanges(initialValue);

  const isRequired = computed(() => rawVoucherInfoStore.isRequired);
  const isReadonly = computed(() => curationExperienceStore.isReadonly);
  const isVisible = useIsVoucherInfoVisible();
  const showRawFields = computed(() => curationExperienceStore.showRawFields);

  const rawInfoVoucher = computed(() => rawSnapshotsQuery.data.value?.rawSnapshot?.raw?.commercial?.info_voucher || "");
  const publishedRawInfoVoucher = computed(
    () => rawSnapshotsQuery.data.value?.publishedRawSnapshot?.raw?.commercial?.info_voucher || ""
  );
  const hasUnpublishedChange = useHasCommercialFieldChange("info_voucher");

  return {
    id: "info_voucher",
    model,
    isRequired,
    isReadonly,
    isVisible,
    isFilled,
    hasChanges,
    hasUnpublishedChange,
    showRawFields,
    rawInfoVoucher,
    publishedRawInfoVoucher,
    reset,
  };
});
